import { useTranslation } from "react-i18next";
import RichTextEditor from "./RichTextEditor";

const QuestionTextInput = (props) => {
    const { t } = useTranslation()
    return (
        <RichTextEditor id="questionText" label={t("questionText")} defaultValue={props.defaultValue} />
    );
};

export default QuestionTextInput;